import { bannerOffset } from '../navigation-onscroll';

export default {
  init() {
    // JavaScript to be fired on all pages
    window.addEventListener('load', bannerOffset);

    const currentSlideContainer = document.getElementById('current-slide');
    const totalSlidesContainer = document.getElementById('total-slides');

    let currentSlideValue = 0;
    let totalSlides = 0;

    if(currentSlideContainer) {
      currentSlideContainer.innerHTML = currentSlideValue;
    }

    if(totalSlidesContainer) {
      totalSlidesContainer.innerHTML = totalSlides;
    }

    $('.modal-carousel').on('init reInit afterChange', function(event, slick, currentSlide) {
      totalSlides = slick.slideCount;

      var i = (currentSlide ? currentSlide : 0) + 1;

      currentSlideContainer.innerHTML = i;
      totalSlidesContainer.innerHTML = slick.slideCount;
    });

    $('.modal-carousel').slick({
      fade: true,
      speed: 150,
      prevArrow: '<button class="btn-arrow btn-prev"><span class="sr-only">Previous slide</span><i class="fa-solid fa-chevron-left"></i></button>',
      nextArrow: '<button class="btn-arrow btn-next"><span class="sr-only">Next slide</span><i class="fa-solid fa-chevron-right"></i></button>',
    });

    $('[id^=modal-gallery-]').on('show.bs.modal', function (e) {
      var index = $(e.relatedTarget).data('index');
      $('.modal-carousel').slick('slickGoTo', index);
    });

    $('[id^=modal-gallery-]').on('hidden.bs.modal	', function () {
      $('.modal-carousel-wrapper').removeClass('open');
    });

    $('[id^=modal-gallery-]').on('shown.bs.modal', function () {
      $('.modal-carousel').slick('setPosition');
      $('.modal-carousel-wrapper').addClass('open');
    });

    // $('.wrappy').on('show.bs.collapse', function (e) {
    //   $(e.target).parent('.person-drawer').addClass('show');
    // })

    // $('.wrappy').on('hidden.bs.collapse', function (e) {
    //   $(e.target).parent('.person-drawer').removeClass('show');
    // })
  },
  finalize() {
    bannerOffset();

    let submitBtn = document.querySelector('.wpforms-submit');
    if(submitBtn) {
      submitBtn.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="14.957" height="7.999" viewBox="0 0 14.957 7.999"><path id="Union_85" data-name="Union 85" d="M13543.457,11344h-6.958v-2h6.958v-3l8,4-8,4Z" transform="translate(-13536.499 -11339.001)" fill="#fff"></path></svg>';
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js